import * as React from "react";
import { ClosedSingleQuestion } from "./ClosedSingleQuestion";
import { ClosedRefinementQuestion } from "./ClosedRefinementQuestion";
import { QuestionsIF } from "./QuestionsIF";
import { QuestionContents } from "./questionElement";
import { NumericTimingQuestion } from "./rangeQuestions/numericQuestions/numericTimingQuestion";
import { numericTimingConfig } from "./rangeQuestions/numericQuestions/numericTimingConfig";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface RefinementQuestionProps extends QuestionsIF {
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const RefinementQuestion = ({ ...props }: RefinementQuestionProps) => {
  const firstSuggestion = props.question?.suggestions?.[0];
  const firstRefinements = firstSuggestion?.refinements;
  const firstRelation =
    firstSuggestion?.suggestion?.qualifiers?.[0]?.relation?.id;

  const isSingleRefinement = firstRefinements?.length === 1;

  const numericQuestionConfig = numericTimingConfig[firstRelation];

  if (numericQuestionConfig) {
    return (
      <QuestionContents>
        <NumericTimingQuestion
          answer={props.answer}
          onAnswer={props.onAnswer}
          question={props.question}
          miniView={props.miniView}
          config={numericQuestionConfig}
        />
      </QuestionContents>
    );
  }

  if (isSingleRefinement) {
    return <ClosedSingleQuestion {...props} />;
  }

  return <ClosedRefinementQuestion {...props} />;
};
